import { isSet } from './object';

export function uuid4() {
  return crypto.randomUUID();
}

export async function sha256(message: string, length?: number) {
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  const hashArray3 = isSet(length) ? hashArray.slice(0, length) : hashArray;
  return hashArray3.map(b => b.toString(16).padStart(2, '0')).join('');
}
